var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatSolid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0004 3C18.8285 3 20.2426 3 21.1213 3.87868C21.1213 3.87868 21.1213 3.87868 21.1213 3.87868C22 4.75736 22 6.17157 22 9C22 9.60249 22 10.2885 22 10.9996C22 13.8283 22 15.2426 21.1213 16.1213C20.2426 17 18.8281 17 15.9991 17C15.4111 17 14.8892 17 14.5 17C12.5 17 9.51529 21 9 21C8.34354 21 8.66869 17 8 17C5.17157 17 3.75736 17 2.87868 16.1213C2 15.2426 2 13.8283 2 10.9996C2 10.2885 2 9.60249 2 9C2 6.17157 2 4.75736 2.87868 3.87868C3.75736 3 5.17145 3 7.99963 3C9.35112 3 10.7535 3 12 3C13.2465 3 14.6489 3 16.0004 3Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSolid);
export default __webpack_public_path__ + "static/media/chat-solid.f2d978d54a9544d35df27ab07ba31b9b.svg";
export { ForwardRef as ReactComponent };